import '@/scripts/init/init.styles';
import '@/layouts/primary/primary-layout.styles';

import './styles/errors.scss';